import Chart from "./chart";
export default Chart;
//# sourceMappingURL=index.js.map